// Central date-display helper — the whole app shows dates as DD-MM-YYYY.
// NOTE: this is for DISPLAY only. API payloads keep their own format (YYYY-MM-DD).

export const formatDate = (
  value?: string | number | Date | null,
  fallback = '-',
): string => {
  if (value === null || value === undefined || value === '') return fallback;
  const d = new Date(value);
  if (isNaN(d.getTime())) return fallback;
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();
  return `${dd}-${mm}-${yyyy}`;
};

// DD-MM-YYYY hh:mm AM/PM
export const formatDateTime = (
  value?: string | number | Date | null,
  fallback = '-',
): string => {
  if (value === null || value === undefined || value === '') return fallback;
  const d = new Date(value);
  if (isNaN(d.getTime())) return fallback;
  const time = d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
  return `${formatDate(value)} ${time}`;
};
